import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import PlayerModel from "models/player/PlayerModel";
import PlayerFooterView from "views/playerFooter/PlayerFooterView";
import PersistentModels from "services/PersistentModels";
import RSVP from "rsvp";

const PlayerController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        if (options) {
            if (options.view) {
                this.view = options.view;
            }
            if (options.model) {
                this.model = options.model;
            }
        }
        this.canBeShownOnActivePage = (options && options.canBeShownOnActivePage) || false;
        this.transparent = (options && options.transparent) || false;

    },

    getModel : function() {
        return this.model;
    },
    
    setCanBeShownOnActivePage : function(canBeShownOnActivePage, transparent){
        this.canBeShownOnActivePage = canBeShownOnActivePage;
        this.transparent = transparent;
        if(this.getView())
        {
            this.getView().setCanBeShownOnActivePage(this.canBeShownOnActivePage, transparent);
        }
    },

    updateActivePageHeightToMatchPlayerFooterHeight : function(){
        $.mobile.resetActivePageHeight(this.canBeShownOnActivePage? window.getDocumentClienHeight() +60: null); 
    },
    
    isPlayerFooterViewDisplayed : function(){
        if(this.getView())
        {
            return this.getView().isPlayerFooterViewDisplayed();
        }
        return false;
    },

    isPlayerFooterViewTransparent : function(){
        return this.transparent;
    },

    getView : function() {
        return this.view;
    },

    showPlayerPage :function(){
        PersistentModels.getInstance().getRouter().showPlayerPage(true, true);
    },
    
    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                if(!this.model)
                {
                    //this.model = new PlayerModel();
                }
                this.view = new PlayerFooterView({"model" : this.model, "canBeShownOnActivePage" : this.canBeShownOnActivePage });
                this.listenTo(this.view, "showPlayerPage", this.showPlayerPage);
                this.view.render().then(resolve);
            //	resolve();
            } catch (error) {
                reject(error);
            }

        }).bind(this));

    }

});

export default PlayerController;